import { get } from 'lodash';
import styles from './richProductNativeMediaSummary.module.scss';
import { RichMediaTemplatePreview } from 'components/RichMediaPreview/RichMediaTemplatePreview';
import { RICH_MEDIA_TEMPLATE_ID, RichMediaType, getMarqueeImageMediaKey, MARQUEE_IMAGE_COUNT } from '../FormContent/RichMediaFormModel';

type mediaSummaryData = {
  richMediaType?: RichMediaType;
  medias: any;
  bannerUrl?: string;
};

export const RichMediaMediaSummary: React.FC<{ mediaSummary: mediaSummaryData }> = ({
  mediaSummary
}) => {
  const richMediaType = mediaSummary.richMediaType ?? RichMediaType.IMAGE_IMAGE;
  const templateId = RICH_MEDIA_TEMPLATE_ID[richMediaType];
  const marqueeImages = Array.from(
    { length: MARQUEE_IMAGE_COUNT },
    (_, index) => get(mediaSummary, `medias.${getMarqueeImageMediaKey(index)}`)
  );

  return (
    <RichMediaTemplatePreview
      className={styles.richProductNativeMediaSummary}
      templateId={templateId}
      barImage={get(mediaSummary, 'medias.barImage')}
      expandImage={get(mediaSummary, 'medias.expandImage')}
      expandVideo={get(mediaSummary, 'medias.expandVideo')}
      marqueeImages={marqueeImages}
      landingPage={get(mediaSummary, 'bannerUrl')}
    />
  );
};
